export default function(api: GlobalFetch) {
  return async function(values, objectId: string, calendarId: string) {
    const response = await api.fetch(
      `/api/v2/pricemulti/integrations/id_object/${objectId}/id_calendar/${calendarId}/`,
      {
        body: JSON.stringify(values),
        method: 'POST',
      },
    )
    if (response.ok) {
      return response.status.toString()
    } else {
      throw new Error(response.status.toString())
    }
  }
}
